import styled from 'styled-components';

export const ProgressReviewWrapper = styled.div`
  padding: 2rem;
  display: flex;
  flex-direction: column;
  width: 100%;

  /* ── Page Title ─────────────────────────────────────────── */
  .progress-review_header {
    margin-bottom: 24px;

    h1 {
      font-weight: var(--font-bold);
      line-height: 46px;
      margin: 0;
    }
  }

  /* ── Filter Area [3] ─────────────────────────────────────── */
  .progress-review_filter {
    display: flex;
    align-items: flex-end;
    gap: 16px;
    flex-wrap: wrap;
    margin-bottom: 20px;
    padding: 16px 20px;
    background: #f9fafb;
    border: 1px solid var(--color-border-primary, #e5e7eb);
    border-radius: 8px;

    .progress-review_filter-item {
      display: flex;
      flex-direction: column;
      gap: 4px;
      min-width: 160px;

      label {
        font-size: var(--font-size-sm);
        font-weight: var(--font-medium);
        color: var(--color-text-secondary, #6b7280);
      }

      .ant-select {
        min-width: 160px;
      }

      /* 年月 [3.1] split Năm/Tháng — giữ width gọn riêng, không áp min-width 160px của select đơn */
      .session-year-month-select_year,
      .session-year-month-select_month {
        min-width: 0;
      }
    }

    .progress-review_refresh-btn {
      height: 40px;
      min-width: 40px;
      width: 40px;
      border-radius: 8px;
      border: 1px solid var(--color-border-primary, #e5e7eb);
      background: #fff;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: background 0.2s;
      margin-bottom: 1px; /* align with select bottom */

      &:hover:not(:disabled) {
        background: #edf2f6;
        border-color: #1d4ed8;
      }

      &:disabled {
        cursor: not-allowed;
        opacity: 0.5;
      }

      .anticon {
        font-size: 16px;
        color: var(--color-text-primary, #111827);
      }
    }
  }

  /* ── Table area [4] ──────────────────────────────────────── */
  .progress-review_table-wrapper {
    border: 1px solid var(--color-border-primary, #e5e7eb);
    border-radius: 8px;
    overflow: hidden;

    /* Row expand/collapse icon [4] — rounded-square chevron button, one per expandable store row */
    .progress-review_expand-icon-btn {
      height: 22px;
      min-width: 22px;
      width: 22px;
      border-radius: 6px;
      border: 1px solid var(--color-border-primary, #d1d5db);
      background: #fff;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: background 0.2s;

      &:hover {
        background: #edf2f6;
        border-color: #1d4ed8;
      }

      .anticon {
        font-size: 12px;
        color: var(--color-text-primary, #111827);
      }
    }

    /* Expand icon cell vertically centered so the button sits level with 会社 [4.1] text */
    .ant-table-row-expand-icon-cell {
      vertical-align: middle;
    }

    .ant-table-thead > tr > th {
      background: var(--background-header-table, #f0f4f8);
      color: var(--color-header-table, #344054);
      font-weight: var(--font-semibold, 600);
      white-space: nowrap;
    }

    /* Numeric columns — right-aligned */
    .progress-review_col-number {
      text-align: right !important;

      &.ant-table-cell {
        text-align: right;
      }
    }

    /* Ellipsis + hover tooltip for 会社/店舗 — same pattern as 資産名称 (InventoryReportPage) */
    .progress-review_ellipsis {
      display: inline-block;
      max-width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      vertical-align: bottom;
    }

    /* Store hyperlink [4.2] */
    .progress-review_store-link {
      color: #1d4ed8;
      text-decoration: none;
      cursor: pointer;
      white-space: nowrap;

      &:hover {
        text-decoration: underline;
        color: #1e40af;
      }
    }

    /* Total footer row [5] — bold */
    .progress-review_total-row {
      td {
        font-weight: var(--font-bold, 700) !important;
        background: #f0f4f8 !important;
        border-top: 2px solid var(--color-border-primary, #e5e7eb);
      }
    }
  }

  /* ── No Data [6] ─────────────────────────────────────────── */
  .progress-review_no-data {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 48px 24px;
    border: 1px solid var(--color-border-primary, #e5e7eb);
    border-radius: 8px;
    color: var(--color-text-secondary, #6b7280);
    font-size: var(--font-size-base);
  }
`;
